import { render, staticRenderFns } from "./ReservedSlots.vue?vue&type=template&id=12a37d08&"
import script from "./ReservedSlots.vue?vue&type=script&lang=js&"
export * from "./ReservedSlots.vue?vue&type=script&lang=js&"
import style0 from "./ReservedSlots.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports